import { pluralize } from '@fourthwall/utils/dist/string';
export const getSyncedProductsHeading = (status, productsLength) => {
    const headingLabelMap = {
        active: 'synced to TikTok',
        pending: 'available to sync to TikTok',
        denied: 'not eligible for TikTok Shop',
    };
    return `${productsLength} ${pluralize(productsLength, 'product')} ${headingLabelMap[status]}`;
};
